export default "__VITE_ASSET__BrsEFYe2__"